var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert",class:[_vm.type],attrs:{"role":"alert"}},[_c('b',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }